export async function getContentInfoFromSignedUrl(url: string, signal?: AbortSignal) {
  const response = await fetch(url, {
    method: 'HEAD',
    signal,
  });

  const type = response.headers.get('Content-Type') ?? '';
  const size = response.headers.get('Content-Length')
    ? parseInt(response.headers.get('Content-Length') ?? '0', 10)
    : 0;

  return {
    type,
    size,
  };
}
